module.exports = __webpack_public_path__ + "img/background2.7d372ab7.jpg";